import { Suspense, lazy } from 'react';
import { PartialRouteObject } from 'react-router';
import BaseLayout from 'src/app/shared/layouts/BaseLayout';
import SuspenseLoader from 'src/app/shared/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Status404 = Loader(
  lazy(() => import('src/app/shared/content/pages/Status/Status404'))
);
const InitPage = Loader(
  lazy(() => import('src/app/feature/InitV2/pages/InitV2Page'))
);
const InitBySlugPage = Loader(
  lazy(() => import('src/app/feature/InitBySlugV2/pages/InitBySlugV2Page'))
);
const MenuPage = Loader(
  lazy(() => import('src/app/feature/MenuV2/pages/MenuV2Page'))
);
const MenuDetailPage = Loader(
  lazy(() => import('src/app/feature/MenuDetailV2/pages/MenuDetailV2Page'))
);
const CartPage = Loader(
  lazy(() => import('src/app/feature/CartV2/pages/CartV2Page'))
);
const CheckoutPage = Loader(
  lazy(() => import('src/app/feature/CheckoutV2/pages/CheckoutV2Page'))
);
const OnvoPaymentPage = Loader(
  lazy(() => import('src/app/feature/OnvoPaymentV2/pages/OnvoPaymentV2Page'))
);

const CardPaymentPage = Loader(
  lazy(() => import('src/app/feature/CardPayment/pages/CardPaymentPage'))
);
const OrderPendingReviewPage = Loader(
  lazy(
    () =>
      import(
        'src/app/feature/OrderPendingReviewV2/pages/OrderPendingReviewV2Page'
      )
  )
);
const LoginPage = Loader(
  lazy(() => import('src/app/feature/Auth/Login/pages/Login'))
);
const RegisterPage = Loader(
  lazy(() => import('src/app/feature/Auth/Register/pages/Register'))
);

// Routes available to a guest (no account). Flow:
// QR → InitPage (loads menu by tableId) → Menu → MenuDetail → Cart → Checkout
// → OnvoPayment (embedded SDK) → PendingReview.
// Excluded: Profile, Orders history, legacy Payment, Cards.
const routesGuest: PartialRouteObject[] = [
  {
    path: '*',
    element: <BaseLayout />,
    children: [
      // Orden de menor a mayor genericidad (L-tap-4). react-router 6.0.0-beta.0
      // matchea por orden de declaración, no por especificidad: /:tableId (1 seg)
      // DEBE quedar al final, justo arriba del catch-all, o se traga /menu, /cart,
      // /checkout. Las de 2 segmentos van antes de /:tableId (que solo matchea 1).
      // 1) Raíz exacta
      {
        path: '/',
        element: <InitPage />
      },
      // 2) Estáticas de 1 segmento
      {
        path: '/menu',
        element: <MenuPage />
      },
      {
        path: '/cart',
        element: <CartPage />
      },
      {
        path: '/checkout',
        element: <CheckoutPage />
      },
      {
        path: '/login',
        element: <LoginPage />
      },
      {
        path: '/register',
        element: <RegisterPage />
      },
      // 3) Rutas de 2 segmentos (dinámica con prefijo + estáticas)
      {
        path: '/menu/detail/:foodId',
        element: <MenuDetailPage />
      },
      {
        path: '/checkout/onvo-payment',
        element: <OnvoPaymentPage />
      },
      {
        path: '/checkout/card-payment',
        element: <CardPaymentPage />
      },
      {
        path: '/checkout/pending-review',
        element: <OrderPendingReviewPage />
      },
      {
        path: '/rest/:slug',
        element: <InitBySlugPage />
      },
      {
        path: '/login/rest/:slug',
        element: <LoginPage />
      },
      {
        path: '/register/rest/:slug',
        element: <RegisterPage />
      },
      {
        path: '/login/:tableId',
        element: <LoginPage />
      },
      {
        path: '/register/:tableId',
        element: <RegisterPage />
      },
      // 4) Dinámica de 1 segmento (la más genérica): justo arriba del catch-all
      {
        path: '/:tableId',
        element: <InitPage />
      },
      // 5) Catch-all
      {
        path: '*',
        element: <Status404 />
      }
    ]
  }
];

export default routesGuest;
